import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { Flex, InlineAlert, Input, Text } from '@cmpsr/components';
import SaveButton from '../../common/save-button';
import { EditPersonalInfoPageProps } from '../edit-personal-info.page';
import EditEmailAddressAction from './edit-email-address-action';

type EditPersonalInfoFormProps = EditPersonalInfoPageProps & {
  handleSubmit: () => void;
  onEditEmailAddressClick: () => void;
};

export default function EditPersonalInfoForm({
  form,
  handleSubmit,
  onEditEmailAddressClick,
}: EditPersonalInfoFormProps) {
  return (
    <form onSubmit={handleSubmit}>
      <FormControl id="personalInfo" isInvalid={!!form.formState.errors.name} mb="spacer-8">
        <FormLabel htmlFor="name">
          <Text variant="text-body-floating-label-regular" textTransform="uppercase" mb="spacer-2">
            name
          </Text>
        </FormLabel>
        <Input
          id="name"
          type="name"
          aria-label="Name"
          variant="outline"
          size="l"
          placeholder="Enter your name"
          isInvalid={!!form.formState.errors.name}
          {...form.register('name', {
            required: 'Please type your name',
          })}
        />
        {form.formState.errors.name?.message && (
          <FormErrorMessage>
            <InlineAlert status="error" mt="spacer-2">
              <InlineAlert.Icon />
              <InlineAlert.Message>{form.formState.errors.name.message}</InlineAlert.Message>
            </InlineAlert>
          </FormErrorMessage>
        )}
        <Text variant="text-body-floating-label-regular" textTransform="uppercase" mb="spacer-2" mt="spacer-4">
          email
        </Text>
        <Flex
          flexDirection={{ base: 'column', lg: 'row' }}
          gap={{ base: 'spacer-4', lg: 'spacer-8' }}
          whiteSpace="nowrap"
        >
          <Input
            id="email"
            type="email"
            aria-label="Email"
            variant="outline"
            size="l"
            isDisabled
            {...form.register('email', {
              required: true,
            })}
          />
          <EditEmailAddressAction onClick={onEditEmailAddressClick} />
        </Flex>
      </FormControl>
      <SaveButton isLoading={form.formState.isSubmitting} />
    </form>
  );
}
